import { Dac8Audit } from '@/features/dac8/dac8-audit';

const Dac8Page = () => <Dac8Audit />;
Dac8Page.displayName = 'Dac8Page';

export default Dac8Page;
